export default __webpack_public_path__ + "static/media/6_center.3acd3996.png";